import { Component, OnInit } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
	
	form: FormGroup
	loggedIn = false
	loggingIn = false

	constructor(private fb: FormBuilder, private dataService: ApiService, private router: Router) {
		this.form = this.fb.group({
			user: ['', [Validators.required, Validators.minLength(1)]],
			pass: ['', Validators.required]
		})
	}

	ngOnInit() {
		this.loggedIn = this.dataService.isLoggedIn()
		if (this.loggedIn) this.redirect()
	}

	redirect() {
		// const redirect = this.dataService.redirectUrl ? this.dataService.redirectUrl : '/my-categories-courses'
		const redirect = this.dataService.redirectUrl ? this.dataService.redirectUrl : '/home'
		this.router.navigateByUrl(redirect)
	}
	
	login(form: FormGroup) {
		let user = form.value.user
		let pass = form.value.pass

		if (user === '' || pass === '') {
			Swal.fire('Error', 'Por favor introduzca usuario y/o contraseña', 'warning')
			return
		}

		this.loggingIn = true

		this.dataService.login(user, pass)
		.subscribe(
			res => {
				// console.log(res)
				if (res === false) {
					this.loggingIn = false
				} else {
					this.redirect()
				}
			},
			error => {
				// console.log(error)
				this.loggingIn = false
				Swal.fire('Error', 'El usuario y/o contraseña son incorrectos', 'error')
			}
		)
	}

	get user() { return this.form.get('user') }
	get pass() { return this.form.get('pass') }
}